<mat-toolbar class="toolbar" color="primary">
  <mat-toolbar-row>
    <a class="title" href="/">
      <img alt="Sonus Space" class="logo-colored" src="assets/sonus-logo_black-letters_green-insert.svg"
           title="Sonus Space"/>
      <img alt="Sonus Space" class="logo-bw" src="assets/sonus-logo_black-letters_white-insert.svg"
           title="Sonus Space"/>
    </a>
    @if (isLoggedIn()?.value) {
      <span class="spacer"></span>
      <button (click)="showSearch()" *ngIf="!searchVisible" aria-label="Global Search" class="search-button"
              mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
      <app-global-search [class.search-visible]="searchVisible" class="search-field"></app-global-search>
      <button [matMenuTriggerFor]="menu" aria-label="Notifications" mat-icon-button>
        <mat-icon [matBadge]="alertBadge()" matBadgeColor="warn">notifications</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="alerts" xPosition="before">
        <app-alert-list [alerts]="alerts" [menuItem]="true" [smallIcon]="false"></app-alert-list>
        <span *ngIf="alerts().length == 0" mat-menu-item>
          <mat-icon color="primary">sentiment_very_satisfied</mat-icon>
          <span>Yay! Nothing requires immediate attention from you right now.</span>
        </span>
        <ng-container *ngIf="snoozedAlertsForUser().length > 0">
          <mat-divider></mat-divider>
          <h4 class="snoozed">Snoozed</h4>
          <app-alert-list [alerts]="snoozedAlertsForUser" [menuItem]="true" [smallIcon]="false"
                          class="snoozed"></app-alert-list>
        </ng-container>
      </mat-menu>
      <span class="small-spacer"></span>
      <a class="current-user-name" matTooltip="Go to User Profile"
         routerLink="/settings/user-profile">{{ currentUser()?.name }}</a>
      <button [matMenuTriggerFor]="settings" aria-label="Settings" class="settings-button" mat-icon-button>
        <mat-icon [matBadge]="unassignedManufacturerBadge()" matBadgeColor="warn">settings</mat-icon>
      </button>
      <mat-menu #settings="matMenu" class="alerts" xPosition="before">
        <a mat-menu-item routerLink="/settings/equipment-catalog">
          <mat-icon>view_list</mat-icon>
          <span>Equipment Catalog</span>
        </a>
        <a mat-menu-item routerLink="/settings/spare-parts-catalog">
          <mat-icon>view_list</mat-icon>
          <span>Service Spare Parts Catalog</span>
        </a>
        <a mat-menu-item routerLink="/settings/manufacturer-responsibility">
          <mat-icon>support_agent</mat-icon>
          <span [matBadge]="unassignedManufacturerBadge()" matBadgeColor="warn">Manufacturer Responsibility</span>
        </a>
        <a mat-menu-item routerLink="/settings/project-import">
          <mat-icon>publish</mat-icon>
          <span>Project Import</span>
        </a>
        <a mat-menu-item routerLink="/settings/users">
          <mat-icon>manage_accounts</mat-icon>
          <span>Users</span>
        </a>
        <button (click)="logout()" aria-label="Logout" mat-menu-item>
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    }
  </mat-toolbar-row>
</mat-toolbar>

@if (isLoggedIn()?.value) {
  <nav [tabPanel]="tabPanel" mat-tab-nav-bar>
    @for (link of links; track link.path) {
      <a #rla="routerLinkActive" [active]="rla.isActive" [routerLink]="link.path" mat-tab-link
         routerLinkActive="mdc-tab-indicator--active">
        <span class="label">{{ link.label }}
          <span (click)="navigateToOnlyWithAlerts(link.path); $event.stopPropagation(); $event.preventDefault()"
                [matBadgeDescription]="'Alerts in '+link.label+' projects'" [matBadge]="link.badge && link.badge()"
                class="badge-link"
                matBadgeColor="warn"> &nbsp;</span></span>
      </a>
    }
  </nav>
}
<mat-tab-nav-panel #tabPanel class="grid-container main-page-container">
  <router-outlet></router-outlet>
</mat-tab-nav-panel>

<!--<div class="sticky-breadcrumbs">
  <button aria-label="Menu" class="menu" mat-icon-button>
    <mat-icon>menu</mat-icon>
  </button>
  <app-breadcrumb class="big-spacer"></app-breadcrumb>
</div>-->

<div class="version">ver {{ buildNumber | slice:0:8 }}
  <span *ngIf="!(buildIsUpToDate$ | async)" class="new">, new {{ buildNumberNew$ | async | slice:0:8 }}</span>
</div>
